import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
// import LanguageSelector from "../LanguageSelector";
import { Button, Card } from "reactstrap";
// import Footer from "../Footer";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import { Server2 } from "../../../redux/actions/auth/auth.actions";
import { FiX } from "react-icons/fi";
import PhoneInput from "react-phone-input-2";
import BusinessHoursComp from "../../BusinessHours";

export default function ArtistJoin({saveUser, user}) {
  // const [offers, setOffers] = useState([]);
  // const [offerInput, setOfferInput] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [websites, setWebsites] = useState(user ? [user.business_info.address.split(`, `)]:[]);
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [businessHours, setBusinessHours] = useState(user ? user.business_info?.business_hours : null);
  const [timeZone, setTimeZone] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [coords, setCoords] = useState([]);
  const [resMsg, setresMsg] = useState("");
  const submitTypeRef = useRef("next");

  // Mapbox Geocoder Setup
  useEffect(() => {
    const fakeMap = new mapboxgl.Map({
      container: document.createElement("div"), // hidden
      accessToken: mapboxgl.accessToken,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [0, 0],
      zoom: 1,
    });

    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl,
      placeholder: "Search city...",
      marker: false,
    });

    const target = document.getElementById("createMicroblogGeocoder");
    target.innerHTML = ""; // cleanup
    target.appendChild(geocoder.onAdd(fakeMap));

    geocoder.on("result", (e) => {
      const place = e.result.place_name;
      const c = e.result.geometry.coordinates;
      // console.log(c, place)

      setSelectedLocation(place);  // Update location text
      setCoords(c);                // Update coordinates
    });
  }, []);

  // URL validation
  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch (err) {
      return false;
    }
  };

  const handleAdd = () => {

    if(websites.length > 3){
      alert("You can upto Four URL addresses for your websites.");
      return;
    }

    if (!inputValue.trim()) return;

    if (!isValidUrl(inputValue)) {
      alert("Please enter a valid URL (include https://)");
      return;
    }

    const updated = [...(websites || []), inputValue];
    setWebsites(updated);
    setInputValue("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  const handleRemove = (index) => {
    const updated = websites.filter((_, i) => i !== index);
    setWebsites(updated);
  };

  const handleEdit = (index) => {
    setInputValue(websites[index]);
    handleRemove(index);
  };

  // Yup Validation Schema
  const validationSchema = Yup.object({
    fname: Yup.string().required("A full name is required"),

    business_name: Yup.string().required("Business name is required"),

    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),

    summary: Yup.string()
      .required("Please add some summary, it is required"),

    artTypes: Yup.array().test(
      "at-least-one",
      "Select at least one option or specify Other",
      function (value) {
        const { otherArt } = this.parent;
        return (value && value.length > 0) || otherArt?.trim();
      }
    ),
  });

  const handleOnChange = (value, data) => {
    setPhone(value.slice(data.dialCode.length));
    setCountryCode((data.countryCode).toUpperCase());
  };

  // Submit to backend API
  const handleSubmit = async (values, {resetForm}) => {

    // if (user){
    //   alert('User Already Added')
    //   return
    // }

    if (websites.length < 1){
      alert('Please Enter at least one website')
      return
    }

    if (!selectedLocation) {
      alert('Please select a location');
      return;
    }
    
    if (!phone || !countryCode) {
      alert('Please enter phone number');
      return;
    }

    const payload = {
      ...values,
      offers: values.otherArt?.trim()
      ? [...values.artTypes, values.otherArt.trim()]
      : values.artTypes,
      coordinates: [{'coords': {'lat': coords[1], 'lng': coords[0]}}],
      location: selectedLocation,
      phone_number: phone,
      country_code: countryCode,
      website: websites.join(", "),
      business_hours: businessHours,
      time_zone: timeZone,
    };

    try {
      var config = {
        method: "POST",
        url: Server2 + "/social/business-add2",
        data: payload,
        headers: { "Content-Type": "application/json" },
      };
      axios(config)
        .then((response) => {
          console.log(response.data, 'im response')
          if (response?.data?.user?.status === 200) {
            setresMsg(response?.data?.user?.message);
            saveUser(response?.data?.user?.user, submitTypeRef.current);
          } else {
            setresMsg(response?.data?.user?.message);
          }
        })
        .catch((error) => {
          console.log("I am Error", error);
        });

    } catch (error) {
      console.log(error);
      alert("Error submitting form!");
    }
  };

  // Initial Values
  const initialValues = user? {
    fname: user?.business_info?.business_owner,
    business_name: user?.fname,
    email: user?.email,
    summary: user?.business_info?.about_company,
    pieces: 0,
    artTypes: [],
    otherArt: ""
  } : {
    fname: "",
    business_name: "",
    email: "",
    summary: "",
    pieces: 0,
    artTypes: [],
    otherArt: ""
  };

  return (
    <div className="bg-light w-100 pb-4" style={{}}>

      <div className="mx-auto px-lg-0 px-2 bg-light">

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ dirty, isValid, handleSubmit }) => (
            <Form onSubmit={handleSubmit} className="pt-3">

              <Card className="px-3 mb-2 rounded-2" style={{ borderTop: 'solid 3px #6148A1' }}>
                <div className="mt-3 mb-2">
                  {resMsg !== "" ? (
                    <div
                      className="text-danger"
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        margin: "2px 28px 10px 28px",
                        textAlign: "center",
                      }}
                    >
                      {resMsg}
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="d-flex align-items-center">
                    <h4 className="">Showcase Your Art on iBouge</h4>&nbsp;<sup className="">®</sup>
                  </div>
                  <p className="">Apply to join our platform and showcase your artwork. Please provide your contact information to set up your account.</p>
                </div>
              </Card>

              {/* F-name */}
              <Card className="p-3 mb-2 rounded-2">
                <h6 className="form-label">Full Name <spam className="text-danger">*</spam></h6>
                <Field
                  type="text"
                  name="fname"
                  className="form-control"
                  placeholder="Enter full name"
                />
                <ErrorMessage
                  name="fname"
                  component="div"
                  className="text-danger"
                />
              </Card>

              {/* B-name */}
              <Card className="p-3 mb-2 rounded-2">
                <h6 className="form-label">Business Name <spam className="text-danger">*</spam></h6>
                <Field
                  type="text"
                  name="business_name"
                  className="form-control"
                  placeholder="Enter full name"
                />
                <ErrorMessage
                  name="business_name"
                  component="div"
                  className="text-danger"
                />
              </Card>

              {/* Email */}
              <Card className="p-3 mb-2 rounded-2">
                <h6 className="form-label">Email Address <spam className="text-danger">*</spam></h6>
                <Field
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter email"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger"
                />
              </Card>

              {/* Phone */}
              <Card className="p-3 mb-2 rounded-2">
                <h6 className="form-label">Phone Number <spam className="text-danger">*</spam></h6>
                <PhoneInput
                  name="Phone"
                  specialLabel={""}
                  country={"us"}
                  inputClass={"form-control form-control-gray"}
                  placeholder="201-555-0123"
                  // countrydata={dialCode}
                  value="phone"
                  onChange={handleOnChange}
                />
              </Card>

              {/* <Card className="p-3 mb-2 rounded-2">
                <h6 className="form-label">Business Category</h6>
                <select
                  className="form-select form-select-sm AccountType"
                  // value={values.bsCategory}
                  name="bsCategory"
                  // onChange={handleChange}
                >
                  <option value="" className="text-danger" disabled hidden>
                    Business Category
                  </option>
                  {businessTypes.map((items) => {
                    return (
                      <option value={items.name} key={items.id}>
                        {items.name}
                      </option>
                    );
                  })}
                </select>
                {errors.bsCategory && touched.bsCategory ? (
                  <div className="error-text">{errors.bsCategory}</div>
                ) : null}
              </Card> */}

              {/* LOCATION - Mapbox Geocoder */}
              <Card className="p-3 mb-2 rounded-2">
                <h6 className="form-label">Location ( City/State/Country ) <spam className="text-danger">*</spam></h6>
                {/* Mapbox Search Box */}
                <div id="createMicroblogGeocoder" name="location" style={{ marginLeft: '0px' }}></div>
              </Card>

              {/* Business Hours */}
              <Card className="p-3 mb-2 rounded-2">
                <div className="d-flex flex-column gap-0">
                  <h6 className="form-label">Business Hours <spam className="text-danger">*</spam></h6>
                  <Button className="ib-btn mt-n1" onClick={() => setIsOpen(true)}>
                    {businessHours === null ? "Add" : "Edit"}
                  </Button>
                </div>
                <table className="mt-2">
                  <tbody>
                    {businessHours ?
                    <tr>
                      <td>Time Zone</td>
                      <td>:&nbsp;</td>
                      <td>{timeZone ? timeZone : 'Not Set' }</td>
                    </tr> : ''
                    }
                    {businessHours?.map((dayInfo, index) => {
                      return (
                        <tr key={index}>
                          <td style={{verticalAlign: 'top'}}>{dayInfo.day}</td>
                          <td style={{verticalAlign: 'top'}}>:&nbsp;</td>
                          <td>
                            {dayInfo.isOff ? (
                              "Closed"
                            ) : (
                              dayInfo.timeSlots.map((slot, idx) => (
                                <div key={idx}>
                                  {slot.opening} - {slot.closing}
                                  {idx !== dayInfo.timeSlots.length - 1 && <br />}
                                </div>
                              ))
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Card>

              {/* Business Offers Tags */}
              <Card className="p-3 mb-2 rounded-2">
                <h6 className="form-label">Preferred Medium(s) of Artwork <spam className="text-danger">*</spam></h6>

                  {[
                    "Painting",
                    "Sculpture",
                    "Photography",
                    "Digital Art",
                    "Drawing/Sketching",
                    "Mixed Media",
                    "Textile/Fiber Art",
                    "Ceramics/Pottery"
                  ].map((item) => (
                    <div className="form-check" key={item}>
                      <Field
                        type="checkbox"
                        name="artTypes"
                        value={item}
                        className="form-check-input"
                        id={item}
                      />
                      <label className="form-check-label" htmlFor={item}>
                        {item}
                      </label>
                    </div>
                  ))}

                  {/* Other */}
                  <div className="mt-2">
                    <label className="form-label">Other</label>
                    <Field
                      type="text"
                      name="otherArt"
                      className="form-control"
                      placeholder="Specify other art type"
                    />
                  </div>

                  <ErrorMessage
                    name="artTypes"
                    component="div"
                    className="text-danger mt-1"
                  />

                {/* <div className="form-control d-flex flex-wrap gap-2" style={{ minHeight: "45px" }}>
                  {offers.map((offer, index) => (
                    <span key={index} className="badge step-input-btn d-flex align-items-center p-2 bg-accent">
                      {offer}
                      <button
                        type="button"
                        className="btn-close btn-close-white ms-2"
                        onClick={() => removeOffer(index)}
                        style={{ fontSize: "10px" }}
                      ></button>
                    </span>
                  ))}

                  <input
                    type="text"
                    className="border-0 flex-grow-1"
                    placeholder="Type and press Enter"
                    value={offerInput}
                    onChange={(e) => setOfferInput(e.target.value)}
                    onKeyDown={handleOfferKeyDown}
                    style={{ outline: "none" }}
                  />
                </div> */}
              </Card>

              {/* Website URL */}
              <Card className="p-3 mb-2 rounded-2">
                <h6 className="form-label">
                  Link to your existing Online Portfolio/Social Media
                  <span className="text-danger"> *</span>
                </h6>

                {/* Pills */}
                <div className="mb-2 d-flex flex-wrap gap-2">
                  {websites &&
                    websites.map((link, index) => (
                      <div className="form-control px-3 py-2 d-flex align-items-center w-auto">
                        <Field
                          name="website"
                          key={index}
                          className="border-0 clamp-1"
                          value={link}
                          style={{ cursor: "pointer", maxWidth: '380px', textWrap: 'nowrap', textOverflow: 'ellipsis' }}
                          onClick={() => handleEdit(index)}
                        />                          
                        <span
                          className="ms-2"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemove(index);
                          }}
                        >
                          <FiX/>
                        </span>
                      </div>
                    ))}
                </div>

                {/* Input + Button */}
                <div className="d-flex gap-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="https://example.com"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <Button className={isValidUrl(inputValue) && websites.length < 4 ? `ib-btn` : ""} onClick={handleAdd}>
                    Add
                  </Button>
                </div>

                <ErrorMessage
                  name="website"
                  component="div"
                  className="text-danger mt-1"
                />
              </Card>

              {/* Business peices */}
              <Card className="p-3 mb-2 rounded-2">
                <h6 className="form-label">How many pieces of artwork do you currently plan to showcase on iBouge? <spam className="text-danger">*</spam></h6>
                <Field name="pieces" as="select" className="form-control">
                  <option className="form-control" value="0" hidden disabled>Choose</option>
                  <option className="form-control" value="1">1-5 pieces</option>
                  <option className="form-control" value="6">6-15 pieces</option>
                  <option className="form-control" value="16">16-30 pieces</option>
                  <option className="form-control" value="31">More than 30 pieces</option>
                </Field>
              </Card>

              {/* Business Summary */}
              <Card className="p-3 mb-2 rounded-2">
                <h6 className="form-label">Please provide a brief artist statement or bio (max 300 words) <spam className="text-danger">*</spam></h6>
                <Field
                  as="textarea"
                  name="summary"
                  className="form-control"
                  rows="5"
                  placeholder="Write a brief summary"
                />
                <ErrorMessage
                  name="summary"
                  component="div"
                  className="text-danger"
                />
              </Card>

              {/* Submit Button */}
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex gap-2">
                <Button
                  type="submit"
                  className="submit-btn ib-btn"
                  disabled={!(dirty && isValid)}
                  onClick={() => {
                    document.documentElement.scrollTop = 0;
                  }}
                >
                  Next
                </Button>
                <Button
                  type="button"
                  className="submit-btn ib-btn"
                  disabled={!(dirty && isValid)}
                  onClick={() => {
                    submitTypeRef.current = "login";
                    handleSubmit();
                  }}
                >
                  Launch my Business Page
                </Button>
                </div>
                <button type="reset" className="me-2 mt-2 border-0">Clear Form</button>
              </div>
            </Form>
          )}
        </Formik>
      </div>

      {isOpen && (
        <BusinessHoursComp
          handleClose={() => setIsOpen(!isOpen)}
          setBusinessHours={(e) => setBusinessHours(e)}
          setTimeZone={(e) => setTimeZone(e)}
          isOpen={isOpen}
        />
      )}

    </div>
  );
}